import { useNavigate } from "react-router";
import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { baseUrl } from "../../../../axios";

function NotificationModal(props) {
  const {
    masque,
    showModal,
    setModalShow,
    isLoading,
    statuses,
    setArg,
    setShowModal,
  } = props;

  const navigate = useNavigate();

  //   Handle data function
  function handleDate(date) {
    let year = date?.slice(0, 4);
    let month = date?.slice(5, 7);
    let day = date?.slice(8, 10);
    let hour = Number(date?.slice(11, 13)) + 7;
    let minute = date?.slice(14, 16);

    let result = `${hour}:${minute}, ${day}/${month}/${year}`;

    return result;
  }

  return (
    <>
      <span
        className="notification-modal__bg"
        style={showModal ? { visibility: "visible" } : { visibility: "hidden" }}
        onClick={() => setShowModal(false)}></span>
      <div
        className="notification-modal"
        style={
          showModal
            ? { transform: "translateY(0)" }
            : { transform: "translateY(100%)", display: "none" }
        }>
        <span className="notification-modal__btn"></span>
        <h2 className="modal__title">Ehson haqida</h2>
        <div className="modal__status-box">
          {/* <p className="modal__status-desc">Status</p> */}
          <div className="modal__status-slider">
            {isLoading ? (
              <CircularProgress />
            ) : (
              <>
                <div className="flex justify-center">
                  <FormControl sx={{ m: 0, minWidth: 150, width: "100%" }}>
                    <Select
                      value={masque?.status || 5}
                      onChange={(e, item) => {
                        setModalShow(true);
                        setArg(Number(e.target.value));
                      }}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}>
                      <MenuItem value="5" disabled>
                        Status
                      </MenuItem>
                      {statuses.slice(1, 5).map((item) => {
                        return (
                          <MenuItem key={item.number} value={item.number}>
                            {item?.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}
          </div>
        </div>
        <div
          onClick={() => {
            navigate(`/mosque-info/${masque?.ad?.mosque?.id}`);
          }}
          className="modal__ad-box">
          <p className="modal__ad-desc">E’lon</p>
          <div className="modal__ad-img-box flex items-center">
            <img
              className="modal__ad-img"
              src={
                masque?.ad?.mosque?.image_src
                  ? `${baseUrl}files/${masque?.ad?.mosque?.image_src}`
                  : "https://cdn.britannica.com/44/102944-050-18D72EC5/Domes-mosque-Malaysia.jpg"
              }
              alt="mosque"
            />

            <div className="modal__ad-texts">
              <h2 className="modal__ad-mosque-name">
                "<span>{masque?.ad?.mosque?.name}</span>"
              </h2>
              <p className="modal__ad-mosque-text">
                {masque?.ad?.amount} {masque?.ad?.amount_type}{" "}
                {masque?.ad?.name} kerak
              </p>
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="pr-1 w-2/4">
            <div className="modal__ad-box w-full">
              <p className="modal__ad-desc">Ehson miqdori</p>
              <span className="modal__ad-sum">
                {masque?.amount} {masque?.currency}
              </span>
            </div>
          </div>
          <div className="pl-1 w-2/4">
            <div className="modal__ad-box w-full">
              <p className="modal__ad-desc">Sana va vaqt</p>

              <span className="modal__ad-sum">
                {handleDate(masque.created_at)}
              </span>
            </div>
          </div>
        </div>
        <div className="modal__ad-box w-full">
          <p className="modal__ad-desc">Izoh</p>
          <p className="modal__ad-user-desc">{masque?.text}</p>
        </div>
        <div className="modal__ad-box w-full">
          <p className="modal__ad-desc">Ehson qiluvchi</p>
          <p className="modal__ad-user-desc">{masque?.user?.full_name}</p>
          <a
            className="modal__ad-user-desc modal__ad-number flex items-center underline"
            href={`tel:${masque?.user?.phone_number}`}>
            {masque?.user?.phone_number}
          </a>
        </div>
      </div>
    </>
  );
}

export default NotificationModal;
